export const MERCHANT_ROUTES = {
	MERCHANT: 'merchant',
};

export const ON_BOARDING_ROUTES = {
	ON_BOARDING: 'onboarding',
	MCC: 'onboarding/mcc'
};

export const ORDERS_ROUTES = {
	ORDERS: 'orders',
	ACTIVITY: 'orders/activity',
	REPORTING: 'reporting'
};
